module.exports = __webpack_public_path__ + "static/img/pay-pt-btn.5b3de47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-pt-btn.png
// module id = DG/e
// module chunks = 1